import {Box, Grid} from '@mui/material';
import PropTypes from 'prop-types';
import {Controller, useFormContext} from 'react-hook-form';

import Checkbox from '../../../../../form/Checkbox/Checkbox';
import FieldLabel from '../FieldLabel/FieldLabel';
import {WEEK_DAYS} from '../utils/utils';

const WeekdaySelector = ({enabled}) => {
  const {control} = useFormContext();

  return (
    <Grid item xs={12} md={5}>
      <FieldLabel>Jours de la semaine</FieldLabel>
      <Box display="flex" flexDirection="column" gap={0.5}>
        {WEEK_DAYS.map(day => (
          <Box key={day.value}>
            <Controller
              disabled={!enabled}
              name={`weekdays.${day.value}`}
              control={control}
              defaultValue={false}
              render={({field}) => <Checkbox {...field} checked={field.value} label={day.label} />}
            />
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

WeekdaySelector.propTypes = {
  enabled: PropTypes.bool.isRequired
};

export default WeekdaySelector;
